import { render, staticRenderFns } from "./ViewContent.vue?vue&type=template&id=2d3a789a"
import script from "./ViewContent.vue?vue&type=script&lang=ts"
export * from "./ViewContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports